export class TopicDto {
  id: string;
  comments: Comment[];
}
